





































































import { Vue, Component } from 'vue-property-decorator';
import data from './data';
import { sendClickLog } from '@/common/js/log';

@Component
export default class App extends Vue {
    private tabList = data.tab;
    private linkList = data.link;
    private transparentNav = true;
    private path = 'index';

    private reload() {
        sendClickLog(`pdjs_${this.path}`, 'icon');
        window.location.href = 'https://paddlejs.baidu.com/';
    }

    private jumpUrl(name, url) {
        if (!url) {
            return;
        }
        sendClickLog(`pdjs_${this.path}`, name);
        window.open(url);
    }

    created() {
        const pathname = window.location.pathname;
        window.spy = new window.SpyClient({
            pid: '3_9',
            lid: new Date().getTime(),
            sample: 1
        });
        if (pathname !== '/'
            && pathname !== '/auth/website'
            && pathname !== '/auth/website/'
        ) {
            this.transparentNav = false;
            const pathList = [
                'doc',
                'demo',
                'model',
                'mobilenet',
                'wine',
                'humanseg',
                'humanStream',
                'gesture',
                'ocrdet',
                'ocr'
            ];
            for (let i = 0; i < pathList.length; i++) {
                const path = pathList[i];
                if (pathname.includes(path)) {
                    this.path = path;
                    break;
                }
            }
        }
        console.log('path ', this.path);
    }
}

